/** The one automatic option, exactly as the ship_via dropdown spells it (the select shows blank otherwise). */
export const LOGIKOR_AUTOMATIC = "Logikor (automatic)";

/**
 * LWI-1433 — one place to answer "is this shipment going via Logikor
 * automatically?", because three different tests for it had diverged.
 *
 * The ship_via dropdown holds 15 values: a single "Logikor (automatic)" and 13
 * manual carriers written as "X (manual)", plus a "Carrier Test" row. Two of
 * those values contain the word "Logikor", so a bare /logikor/i test is wrong —
 * "Manual Logikor (manual)" is a manual option and matches it.
 *
 * Match on the "automatic" marker instead, the way LWI-1145's default-selection
 * already does.
 */
export function isLogikorAutomatic(shipVia) {
  return /logikor.*automatic/i.test(String(shipVia ?? ""));
}

/**
 * True when a carrier is chosen and it is not the automatic Logikor option, so
 * the user has to arrange the shipment and record the BOL details themselves.
 *
 * Deliberately "not automatic" rather than "is manual": that way "Carrier Test"
 * and any option added later warn by default. Over-warning is the safe
 * direction — the cost of a missed warning is an unrecorded shipment.
 */
export function needsManualShippingWarning(shipVia) {
  const value = String(shipVia ?? "").trim();
  return value !== "" && !isLogikorAutomatic(value);
}
